// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__hq1gX","bonusDetails":"Home_bonusDetails__jut1g","promoText":"Home_promoText__2Zm7t","promoBanner":"Home_promoBanner__J6HtA"};